// Every permission code Phoenix checks. Names match Maverick's enum for the same code; values are the exact strings the backend sends.
export enum Permission {
  VIEW_LEGS = 'VIEWLEGS',
  ADD_TO_AVINODE = 'ADDAVINODE',
  CANCEL_AVINODE_TRIP = 'CANCELAVINODETRIP',

  // Aviation master data, managed in Maverick
  VIEW_AIRPORT = 'VIEWAIRPORT',
  VIEW_AIRCRAFT = 'VIEWAIRCRAFT',
  EDIT_AIRCRAFT = 'EDITAIRCRAFT',
  VIEW_OPERATOR = 'VIEWOPERATOR',
  VIEW_FBO = 'VIEWFBO',
}
